export const PACKAGES = [
  {
    name: "The Short List",
    price: 550,
    hours: "3 hours",
    tagline: "For the intimate gathering.",
    includes: ["3 hours on-site", "Delivery, setup & teardown", "Self-serve vintage booth", "Edited highlight video (2–3 min)", "All raw clips delivered", "14-day delivery"],
    featured: false,
  },
  {
    name: "The Main Event",
    price: 625,
    hours: "4 hours",
    tagline: "The one most people book.",
    includes: ["4 hours on-site", "Delivery, setup & teardown", "Self-serve vintage booth", "Edited highlight video (2–3 min)", "All raw clips delivered", "14-day delivery"],
    featured: true,
  },
  {
    name: "The Encore",
    price: 700,
    hours: "5 hours",
    tagline: "For the party that won't quit.",
    includes: ["5 hours on-site", "Delivery, setup & teardown", "Self-serve vintage booth", "Edited highlight video (2–3 min)", "All raw clips delivered", "14-day delivery"],
    featured: false,
  },
];

export const ADDONS = [
  { label: "Travel beyond 30km of base", price: "$5/km", note: "Capped at $200 — quoted upfront, no surprises." },
  { label: "Extra hour on-site", price: "+$100/hr", note: "Subject to availability on the day." },
  { label: "Custom prompt card / branded intro slide", price: "+$50", note: "Make it yours." },
  { label: "Rush edit (7 days instead of 14)", price: "+$100", note: "When you can't wait." },
];

export const EVENT_TYPES = [
  { title: "Weddings", copy: "More than a signature in a book — a message your guests will actually rewatch.", tag: "01" },
  { title: "Birthdays", copy: "Your kid's first birthday, 30th, 40th, 60th, retirements. The stories come out after the second drink.", tag: "02" },
  { title: "Grads", copy: "Freeze this chapter. They'll thank you in ten years.", tag: "03" },
  { title: "Corporate", copy: "Your business opening, team send-offs, launches, milestones. Warm, not corporate.", tag: "04" },
];

export const STEPS = [
  { n: "01", title: "Book your date", copy: "Send your date and details. We reply within 24 hours with availability and a flat quote." },
  { n: "02", title: "We set up", copy: "We arrive and set up the vintage booth. Guests pick up the receiver and speak from the heart to the camera. There will be professional staff and signage to assist guests." },
  { n: "03", title: "You rewatch it", copy: "A beautifully edited highlight video — plus every raw clip — lands in your inbox within 14 days." },
];

export const FAQS = [
  { q: "What does the booth look like?", a: "A vintage-camera-style video booth — warm, inviting, and unmistakably analog. For a real look at it in action, please refer to our Gallery or our Instagram @thee.ventclub." },
  { q: "How do guests use it — is it awkward?", a: "Not at all. Guests walk up, pick up the receiver, and leave a message. Hang up, and your message is recorded and stays with us forever. Signage explains everything, and a professional staff member will be there to assist." },
  { q: "What's the video quality?", a: "We record in crisp, high-quality video with an external microphone, so every message comes through sharp and clearly audible — not tinny phone audio." },
  { q: "Who owns the footage?", a: "You get a full copy of both the raw clips and the edited highlight video. We retain rights to the footage and may use short, anonymized clips in marketing unless you opt out in the contract. Guests can always decline recording — signage at the booth makes that clear." },
  { q: "What if it rains or the venue changes?", a: "The booth lives happily indoors, or outdoors under cover. If plans shift, just let us know. One free reschedule is included with 14+ days' notice." },
  { q: "How long until we get our video?", a: "Your edited highlight video and all raw clips are delivered within 14 days. Need it faster? A 7-day rush edit is available for +$100." },
  { q: "Do you need power and wifi at the venue?", a: "We need one standard power outlet within reach. Wifi is not required — everything records locally." },
  { q: "Do you charge for travel?", a: "Flat pricing applies within 30km of our Lower Mainland base. Beyond that it's $5/km, capped at $200, and always quoted upfront before you commit." },
];

export const SERVICE_AREAS = ["Vancouver", "Burnaby", "Richmond", "Surrey", "Coquitlam", "North Shore", "New Westminster", "Langley"];

export const EVENT_TYPE_OPTIONS = ["Wedding", "Birthday / Milestone", "Graduation", "Anniversary", "Baby Shower", "Corporate Event", "Other"];
export const HOURS_OPTIONS = ["3 hours (The Short List)", "4 hours (The Main Event)", "5 hours (The Encore)", "Not sure yet"];
export const HEARD_OPTIONS = ["Instagram", "Google search", "A friend / referral", "Wedding planner", "WeddingWire / EventSource", "Other"];
